import { render, staticRenderFns } from "./AdminShipperPricesTable.vue?vue&type=template&id=71ce14d2"
import script from "./AdminShipperPricesTable.vue?vue&type=script&lang=js"
export * from "./AdminShipperPricesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ce14d2')) {
      api.createRecord('71ce14d2', component.options)
    } else {
      api.reload('71ce14d2', component.options)
    }
    module.hot.accept("./AdminShipperPricesTable.vue?vue&type=template&id=71ce14d2", function () {
      api.rerender('71ce14d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminShipperPricesTable.vue"
export default component.exports